import { render, staticRenderFns } from "./PromotionCounter.vue?vue&type=template&id=d9809816&scoped=true&"
import script from "./PromotionCounter.vue?vue&type=script&lang=js&"
export * from "./PromotionCounter.vue?vue&type=script&lang=js&"
import style0 from "./PromotionCounter.vue?vue&type=style&index=0&id=d9809816&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9809816",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
